/**
 * WordPress dependencies
 */
import { useMemo } from '@safe-wordpress/element';
import { type WordPressComponentProps } from '@safe-wordpress/components';

/**
 * Internal dependencies
 */
import { useCx } from '../../utils';
import { useContextSystem } from '../../context';
import * as styles from '../styles';
import type { VisualizerProps } from '../types';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useBorderBoxControlVisualizer(
	props: WordPressComponentProps< VisualizerProps, 'div' >
) {
	const {
		className,
		value,
		size = 'default',
		...otherProps
	} = useContextSystem( props, 'BorderBoxControlVisualizer' );

	// Generate class names.
	const cx = useCx();
	const classes = useMemo( () => {
		return cx(
			styles.borderBoxControlVisualizer( value, size ),
			className
		);
	}, [ cx, className, value, size ] );

	return { ...otherProps, className: classes, value };
}
